import { render } from "./IpChooser.vue?vue&type=template&id=c567acae"
import script from "./IpChooser.vue?vue&type=script&lang=js"
export * from "./IpChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__